import { render } from "./indexthreedoctor.vue?vue&type=template&id=612aeb93"
import script from "./indexthreedoctor.vue?vue&type=script&lang=js"
export * from "./indexthreedoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__